module.exports = __webpack_public_path__ + "static/baker-beach.resized-a809ed86cbc8ef7fd99d3fdaa982c716.jpg";